<!-- 显示更多信息 -->
<template>
    <div>
        <!-- 显示更多信息的对跨框 -->
        <el-dialog
                :visible.sync="show"
                @closed="closed"
                width="55%"
                :append-to-body="true"
                :title="title">
            <el-tabs v-model="activePane">
                <!-- 订单的尺码 -->
                <el-tab-pane label="尺码信息" name="sizeOrder">
                    <el-form :inline="true" label-width="auto" :model="formData">
                        <el-row>
                            <el-form-item label="分类:">
                                <el-select size="mini" v-model="formData.kind">
                                    <el-option value="FACTORY" label="工厂生产单"></el-option>
                                    <el-option value="BUY" label="采购配饰单"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="是否加急:">
                                <el-select size="mini" v-model="formData.urgent">
                                    <el-option :value="true" label="加急"></el-option>
                                    <el-option :value="false" label="不加急"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <el-table :show-summary="true" :data="formData.ordersize_set">
                            <el-table-column prop="size.shop_id" label="尺码"/>
                            <el-table-column prop="color" label="颜色"/>
                            <el-table-column align="center" prop="ordered_amount" label="下单数量">
                                <template slot-scope="{ row }">
                                    <el-input-number
                                            size="mini"
                                            v-model="row.ordered_amount"
                                            :step="1"
                                            :min="0">

                                    </el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column prop="finish_in_storage" label="入库数量">

                            </el-table-column>
                        </el-table>
                    </el-form>
                    <el-row style="margin:10px 0">
                        <el-button :disabled="!isVerity" :loading="updateLoading" @click="updateOrderClick" size="mini"
                                   type="primary">修改订单
                        </el-button>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="备注信息" name="remarks">

                    <el-dialog
                            @closed="remarkClosed"
                            width="35%"
                            title="新增备注信息"
                            :visible.sync="createRemarkShow"
                            :append-to-body="true">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 5}"
                                placeholder="请输入备注信息"
                                v-model="newRemark">
                        </el-input>
                        <el-button style="margin: 10px 0" :loading="createRemarkLoading" @click="createNeWRemarkClick"
                                   size="mini"
                                   type="primary">
                            完成
                        </el-button>
                        <span slot="footer" class="dialog-footer">
                            <el-button size="mini" @click="createRemarkShow=false">取 消</el-button>
                        </span>
                    </el-dialog>
                    <el-table :data="remarks">
                        <el-table-column width="80" prop="created_user.username" label="创建人"/>
                        <el-table-column width="160" prop="created_time" label="创建时间"/>
                        <el-table-column prop="remark" label="信息"/>
                    </el-table>
                    <el-row style="margin: 10px 0">
                        <el-button @click="createRemarkShow=true" icon="el-icon-circle-plus" size="mini" type="primary">
                            增加备注
                        </el-button>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="日志" name="systemLog">
                    <el-table :data="systemLogs">
                        <el-table-column width="80" prop="created_user.username" label="创建人"/>
                        <el-table-column width="160" prop="created_time" label="创建时间"/>
                        <el-table-column prop="remark" label="信息"/>
                    </el-table>
                </el-tab-pane>
            </el-tabs>


            <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="close">取 消</el-button>
  </span>
        </el-dialog>

        <!-- 对话框的关闭按钮 -->
        <el-button @click="open" type="primary" size="mini">
            更多信息
        </el-button>
    </div>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "OrderMore",
        props: {
            order: Object
        },
        data() {
            return {
                show: false,
                formData: {
                    kind: '',        // 分类
                    urgent: '',      // 加急
                    ordersize_set: [],   // 尺码信息
                },

                updateLoading: false, // 显示正在更新的 Loading

                activePane: 'sizeOrder',       // 当前 Tabs 标签页

                newRemark: '',                  // 新增的备注信息
                createRemarkShow: false,
                createRemarkLoading: false,
            }
        },
        computed: {
            /**
             * 订单日志信息
             */
            systemLogs() {
                return this.order.orderremark_set.filter(remark => {
                    return remark.is_system
                }).reverse()
            },

            /**
             * 备注信息
             */
            remarks() {
                return this.order.orderremark_set.filter(remark => {
                    return !remark.is_system
                }).reverse()
            },

            /**
             * 订单是否处于审核阶段
             *
             * 只有审核阶段可以能够订单数据
             */
            isVerity() {
                return this.order.status === 'VERIFY_ORDER'
            },

            /**
             * 对话框标题
             */
            title() {
                if (this.order) {
                    return this.order.order_base.base_id
                }
                return ''
            },

            ...mapState(['currentUserInfo',])
        },
        methods: {
            /**
             * 关闭对话框
             */
            close() {
                this.show = false
            },

            /**
             * 打开对话框
             */
            open() {
                this.show = true
            },

            /**
             * 关闭对话框后的处理事件
             */
            closed() {
                this.initFormData()
                this.activePane = 'sizeOrder'
            },

            /**
             * 保存新增备注信息
             */
            createNeWRemarkClick() {
                this.createRemarkLoading = true
                const url = '/order_platform/api/order_remarks/'
                const data = {
                    platform_order: this.order.id,
                    remark: this.newRemark,
                    is_system: false
                }
                this.$postRequest(url, data)
                    .then(response => {
                        const newOrder = JSON.parse(JSON.stringify(this.order))
                        newOrder.orderremark_set.push(response.data)
                        this.updateOrder(newOrder)
                        this.createRemarkLoading = false
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '新增备注成功'
                        })
                        this.newRemark = ''
                    })
                    .catch(error => {
                        this.createRemarkLoading = false
                    })

            },

            /**
             * 关闭新增备注对话框
             */
            remarkClosed() {
                this.newRemark = ''
            },

            /**
             * 对表单数据进行初始化/刷新
             */
            initFormData() {
                if (this.order) {
                    this.formData.kind = this.order.kind
                    this.formData.urgent = this.order.urgent
                    this.formData.ordersize_set.length = 0
                    this.order.ordersize_set.forEach(orderSize => {
                        const newOrderSize = JSON.parse(JSON.stringify(orderSize))
                        this.formData.ordersize_set.push(newOrderSize)
                    })
                }
            },

            /**
             * 检查账号是否有相关权限
             * 如果有权限返回 true, 否则返回 false
             */
            authCheck() {
                // 11 是超级管理员
                if (this.currentUserInfo.id === this.order.created_user.id
                    || this.currentUserInfo.id === 11) {
                    return true
                }
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: '权限不足！'
                })
                return false
            },

            /**
             * 点击 `更新订单` 按钮事件
             */
            updateOrderClick() {
                if (this.authCheck()) {
                    this.updateLoading = true
                    const url = `${this.$const.orderListUrl}${this.order.id}/`
                    const data = {
                        kind: this.formData.kind,
                        urgent: this.formData.urgent,
                        ordersize_set: [],       // 只更新下单数量
                    }
                    this.formData.ordersize_set.forEach(orderSize => {
                        data.ordersize_set.push({
                            id: orderSize.id,
                            ordered_amount: orderSize.ordered_amount
                        })

                    })
                    this.$patchRequest(url, data).then(response => {
                        this.updateLoading = false
                        const order = response.data
                        this.updateOrder(order)
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '更新完成'
                        })
                    }).catch(error => {
                        this.updateLoading = false
                    })
                }

            },

            ...mapMutations(['updateOrder'])
        },
        created() {
            this.initFormData()
        },
        watch: {
            /**
             * 监测 order 对象
             */
            order() {
                this.initFormData()
            },
        },

    }
</script>

<style scoped>

</style>